import { Injectable } from '@angular/core';

declare global {
  interface Window {
    ttq?: {
      track: (event: string, params?: Record<string, unknown>) => void;
      page: () => void;
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class TikTokService {

  trackEvent(eventName: string, params?: Record<string, unknown>): void {
    if (window.ttq) {
      window.ttq.track(eventName, params || {});
    }
  }
}
